import { render, staticRenderFns } from "./TheAppBarPersonificar.vue?vue&type=template&id=fda5c11a&"
import script from "./TheAppBarPersonificar.vue?vue&type=script&lang=js&"
export * from "./TheAppBarPersonificar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports